<template>
  <div style="height: 100%">
    <app-header></app-header>

    <!-- Left side column. contains the sidebar -->
    <app-sidebar></app-sidebar>

    <!-- Content Wrapper. Contains page content -->
    <router-view></router-view>
    <!-- /.content-wrapper -->

<!--    <app-footer></app-footer>-->

    <control-sidebar></control-sidebar>
  </div>
</template>

<script>
  import Sidebar from './partials/Sidebar.vue'
  import Header from './partials/Header.vue'
  import Footer from './partials/Footer.vue'
  import ControlSidebar from './partials/ControlSidebar.vue'

  export default {
    name: 'Dashboard',
    data: function () {
      return {}
    },
    mounted: function () {
      // 铃铛提醒会有布局错误，所以这里重新刷了一次
      // if (location.href.indexOf('#isFirst') === -1) {
      //   location.href = location.href + "#isFirst";
      //   location.reload();
      // }
    },
    methods: {
    },
    components: {
      'app-sidebar': Sidebar,
      'app-header': Header,
      'app-footer': Footer,
      'control-sidebar': ControlSidebar
    }
  }
</script>



// WEBPACK FOOTER //
// Dashboard.vue?6a0ccf38